module.exports = __webpack_public_path__ + "src/assets/games/42/302.jpg";